var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.logoSrc,"alt":_vm.$config.runtime.domain,"loading":_vm.isLazy ? 'lazy' : 'eager'}})
}
var staticRenderFns = []

export { render, staticRenderFns }